// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".netto-header-magazine[data-v-8f8b7e24]{color:var(--body-color);font-size:14px;-webkit-text-decoration:none;text-decoration:none}.netto-header-magazine[data-v-8f8b7e24]:hover{color:var(--primary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
